export interface IPNPlanSubmission {
    id: string;
    unitID: string;
    pnBegins: string;
    pnEnds: string;
    lastSubmitted: string;
    lastErrorCode: string;
    submissionAttempts: number;
    state: PNPlanSubmissionState;
}

export enum PNPlanSubmissionState {
    Outstanding = 0,
    Failed = 1,
    Succeeded = 2
}